// extracted by mini-css-extract-plugin
export default {"container":"VUaGG","mobileContainer":"HUkAg","overlay":"Lia6z"};